import { observer } from "mobx-react-lite";

import { twMerge } from "@/utils/twMerge";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type Props = {
  node: DecoratorNodeModel;
  isSelected?: boolean;
};

export const Boxed = observer(function Boxed({ node: _node, isSelected }: Props) {
  return (
    <div
      className={twMerge(
        "absolute inset-0 border border-gray-500 rounded-3",
        isSelected && "fromSm:bg-selected-bg",
      )}
    />
  );
});
